<template lang="pug">
    v-dialog(
        v-model="dialog" 
        fullscreen 
        hide-overlay 
        transition="dialog-bottom-transition"
    )    

        template(v-slot:activator="{ on, attrs }")
            div
                v-icon(
                    color="#AAAAAA"
                    slot="activator"
                    small
                    title="View Detail"
                    v-bind="attrs"
                    v-on="on"
                    class="icon-detail"
                ) remove_red_eye

        v-card(style="background: #F3F3F4;")
            v-app-bar(
                :color='colorTheme'
                class="navFixed"
                height="48px;"
            )
                v-toolbar-title(style="font-size: 18px; font-weight: 700; color: white" class="ml-3") Navbar Preview
                v-spacer
                v-toolbar-items
                    v-btn(dark text  @click.native="dialog = false")
                        v-icon(title="Close") cancel
                        | &nbsp;Close

            v-container
                v-card
                    v-toolbar.elevation-0(color="white")
                        v-toolbar-title Demo Homepage
                    v-divider
                    v-card-text 
                        h3(style="font-weight: 400; color: black;") Welcome to i-Memo TechConnect
                        p.mt-2 This iMemo is platform will support all NonGroup memo activities
                        div(class="grey lighten-4 mt-5 pa-6" class="image-head")
                            div(class="text-center")
                                h2 Getting started
                                p.mt-2 Great to have you on board! Feel free to explore, or get a head start below.
                            v-row
                                v-col(cols="6" md="4")
                                    v-card(
                                        style="min-height: 200px; padding:2rem"
                                        class="custom-card"
                                        outlined
                                        tile
                                    ) 
                                        v-icon(class="card-icon") person_pin
                                        div(class="card-title") Start Creating User
                                        div(class="card-subtitle") Create a new user and work with rest of the team.
                                v-col(cols="6" md="4")
                                    v-card(
                                        style="min-height: 200px; padding:2rem"
                                        class="custom-card"
                                        outlined
                                        tile
                                    ) 
                                        v-icon(class="card-icon") live_help
                                        div(class="card-title") Frequently Asked Questions
                                        div(class="card-subtitle") Have a question about iMemo? We are here to help.
                                v-col(cols="6" md="4")
                                    v-card(
                                        style="min-height: 200px; padding:2rem"
                                        class="custom-card"
                                        outlined
                                        tile
                                    ) 
                                        v-icon(class="card-icon") image
                                        div(class="card-title") Start Edit Logo
                                        div(class="card-subtitle") Edit business unit logo and business unit tagline
</template>

<script>
export default {
  name: "PreviewThemeColor",
  props: {
    color: String
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    colorTheme: function() {
      return this.color ? this.color : '#D42A2A';
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

div .image-head{
    background-image:url("../assets/bg.png");
    width: auto;
}

.v-toolbar__content {
  box-shadow: none;
}

a{
    text-decoration: none;
}

.custom-card{
    padding: 3rem;
    text-align: center;
}

.card-title{
    font-size: 16px;
    color: #646464;
    font-weight: 600;
}

.card-subtitle{
    font-size: 14px;
    color: #A7A7A7;
}

.theme--light.v-card .custom-card:hover{
    background: #1976D2;
    color: #fff !important;
}

.theme--light.v-card .custom-card:hover .card-title {
    color: #fff;
}

.theme--light.v-card .custom-card:hover .card-subtitle {
    color: #fff;
}

.theme--light.v-card .custom-card:hover .card-icon {
    color: #fff !important;
}

.card-icon{
    color: #1976D2 !important;
    margin-bottom: 0.4rem;
}

.custom-card.theme--light.v-sheet--outlined {
    border: 2px solid #EFEFF0;
}
</style>
